// Trading strategies — RE₿EL LLM pipeline translation (Sprint B).
// tipo/nivel keys preserved from ES for cross-locale filter/color consistency.

export const ESTRATEGIAS = [
  {
    id: "smc-order-block",
    nombre: "SMC — 订单块入场",
    tipo: "tendencia",
    mercados: [
      "BTC",
      "ETH",
      "Altcoins"
    ],
    timeframes: [
      "1H",
      "4H",
      "D"
    ],
    dificultad: "intermedia",
    winRate: "55-65%",
    ratioRR: "1:3 — 1:5",
    descripcion: "在结构突破（BOS）后，在订单块区域进行机构级入场。这是Smart Money Concepts的核心策略。寻找价格回测机构下单区域，与机构一起入场。",
    condicionesEntrada: [
      "1. 在更高时间框架（D或4H）识别趋势。",
      "2. 等待趋势方向的Break of Structure（BOS）。",
      "3. 识别导致BOS的Order Block（冲动前最后一根反向蜡烛）。",
      "4. 等待价格回到Order Block范围（回撤）。",
      "5. 在较低时间框架（1H或15m）确认结构：OB处的看涨CHoCH。",
      "6. 在OB上半部分入场（OB内的折扣区）。"
    ],
    stopLoss: "设在Order Block最低点下方（留0.5%小幅余量）。",
    takeProfit: "下一个流动性区域/前高/斐波那契161.8%扩展位。",
    ejemploReal: "BTC在4H图表显示看涨BOS突破44,000。看涨OB位于42,800-43,200（冲动前最后一根红色蜡烛）。价格回到43,000，1H图表形成看涨CHoCH。在43,100入场，止损42,700，目标45,500。风险回报比≈1:3。",
    erroresComunes: [
      "在OB处入场而不等待较低时间框架确认。",
      "未正确识别更高时间框架的趋势。",
      "止损设置在OB内过紧——价格可能扫掉止损。",
      "将OB与随机盘整区混淆。"
    ],
    consejosPro: [
      "上方带有FVG的OB更强大——双重机构汇合。",
      "最有效的OB是导致最近BOS的那个。",
      "最好忽略已被测试超过2次的OB。",
      "结合流动性：当价格先猎杀止损然后回到OB时入场。"
    ]
  },
  {
    id: "fvg-fill",
    nombre: "FVG填补——低效区回补",
    tipo: "reversion",
    mercados: [
      "BTC",
      "ETH",
      "Todos"
    ],
    timeframes: [
      "15m",
      "1H",
      "4H"
    ],
    dificultad: "basica",
    winRate: "60-70%",
    ratioRR: "1:2 — 1:3",
    descripcion: "价格倾向于回补由剧烈冲动创造的Fair Value Gaps（FVG）。该策略利用市场寻求价格平衡的趋势。当与结构汇合使用时，简单且高概率。",
    condicionesEntrada: [
      "1. 识别带有可见FVG的强劲冲动（看涨或看跌）。",
      "2. FVG是蜡烛1的上影线与蜡烛3的下影线之间的空间。",
      "3. 等待价格回撤至FVG。",
      "4. 最好FVG与Order Block或支撑/阻力区重合。",
      "5. 在FVG的50%处入场（缺口中点）。",
      "6. 用拒绝蜡烛或较低时间框架结构确认。"
    ],
    stopLoss: "设在完整FVG下方（如果价格完全穿过，FVG不再有效）。",
    takeProfit: "FVG形成起点——原始冲动位置。",
    ejemploReal: "ETH看涨冲动从2,200至2,450。FVG位于2,280-2,320。价格回撤至2,300，出现十字星犹豫蜡烛。在2,300入场，止损2,270，目标2,420。风险回报比≈1:4。",
    erroresComunes: [
      "在已被填补的FVG入场——已填补的FVG失去磁性。",
      "忽略宏观趋势——逆趋势操作FVG概率较低。",
      "非常小的FVG（<0.5%）统计可靠性较低。"
    ],
    consejosPro: [
      "与Order Blocks汇合的FVG最强大。",
      "FVG填补一半（50%）后被拒绝是非常强的信号。",
      "在上升趋势中，只操作看涨FVG。不要逆势而为。",
      "开盘时段（伦敦、纽约）的FVG填补率高。"
    ]
  },
  {
    id: "wyckoff-accumulation",
    nombre: "Wyckoff——吸筹阶段入场",
    tipo: "reversion",
    mercados: [
      "BTC",
      "ETH"
    ],
    timeframes: [
      "4H",
      "D",
      "W"
    ],
    dificultad: "avanzada",
    winRate: "50-60%",
    ratioRR: "1:5 — 1:10",
    descripcion: "Richard Wyckoff在1930年代开发了一种方法来理解机构操作者如何吸筹和派发仓位。吸筹阶段是大资金在大涨前悄悄买入的时期。正确识别它提供市场上最佳的风险回报比。",
    condicionesEntrada: [
      "1. Preliminary Support（PS）：强烈下跌后的首次反弹——买方兴趣的首个迹象。",
      "2. Selling Climax（SC）：极端看跌蜡烛伴随极高交易量——恐慌性抛售。",
      "3. Automatic Rally（AR）：从SC强劲反弹——定义区间顶部。",
      "4. Secondary Test（ST）：回到SC水平但交易量较少——确认。",
      "5. Creek（阻力）：价格在区间内震荡，形成高点和低点。",
      "6. Jump Across the Creek（JAC）：明确突破区间顶部伴随交易量。",
      "7. Back Up to the Creek（BU）：回测突破——最后入场机会。",
      "8. 在BU处入场，止损设在吸筹区间下方。"
    ],
    stopLoss: "日线蜡烛收盘于吸筹区间（Selling Climax）下方。",
    takeProfit: "从突破点投射吸筹区间高度×2-3。",
    ejemploReal: "BTC在2020年：吸筹区间6,000-12,000。2020年3月SC约4,000。AR至10,000。6K-12K区间持续6个月。2020年10月JAC。BU至12,000。入场12,500，止损9,000，目标30,000+。实际风险回报比：1:10+。",
    erroresComunes: [
      "在只有派发的地方识别吸筹——混淆阶段。",
      "在JAC之前入场——区间可能持续数周或数月。",
      "不等待BU——在JAC入场风险回报比较低。"
    ],
    consejosPro: [
      "交易量在Wyckoff中至关重要——没有交易量就没有确认。",
      "更长的吸筹区间（3-6个月）产生最佳走势。",
      "BTC周线图在2019-2020和2022-2023显示非常清晰的Wyckoff。",
      "结合链上数据：Wyckoff吸筹+交易所流出=非常强的信号。"
    ]
  },
  {
    id: "breakout-retest",
    nombre: "突破+阻力回测",
    tipo: "ruptura",
    mercados: [
      "Todos"
    ],
    timeframes: [
      "1H",
      "4H",
      "D"
    ],
    dificultad: "basica",
    winRate: "55-65%",
    ratioRR: "1:2 — 1:4",
    descripcion: "最经典且有效的策略之一。价格伴随交易量突破关键阻力位，回测该水平（现为支撑位），提供低风险的顺势入场机会。回测确认旧顶部成为新底部。",
    condicionesEntrada: [
      "1. 识别明确定义的阻力位（至少2-3次触碰）。",
      "2. 等待蜡烛明确收盘于阻力位上方的突破。",
      "3. 用突破蜡烛上高于平均的交易量确认。",
      "4. 等待回测——价格回到触碰突破线。",
      "5. 在回测时，寻找该水平的拒绝蜡烛（十字星、锤子线、吞没）。",
      "6. 在回测确认蜡烛收盘时入场。"
    ],
    stopLoss: "设在回测确认蜡烛最低点下方（或突破阻力位下方）。",
    takeProfit: "从突破水平投射先前区间高度。",
    ejemploReal: "BTC阻力位在48,000，2个月内4次触碰。日线蜡烛收盘于49,500突破，交易量×2。回测至48,200，锤子线确认。入场48,500，止损47,200，目标54,000。风险回报比≈1:4。",
    erroresComunes: [
      "在突破时入场而不等待回测——假突破风险高。",
      "回测不总是到达精确水平——给予±1-2%余量。",
      "无交易量的突破失败率高。"
    ],
    consejosPro: [
      "理想的回测以低于突破时的交易量触碰水平。",
      "如果回测远低于水平，设置失效。",
      "结合EMA200或Order Block作为额外汇合。",
      "在加密货币中，历史新高（ATH）的突破特别强大。"
    ]
  },
  {
    id: "london-breakout",
    nombre: "伦敦开盘突破",
    tipo: "ruptura",
    mercados: [
      "BTC",
      "ETH"
    ],
    timeframes: [
      "15m",
      "1H"
    ],
    dificultad: "basica",
    winRate: "55-60%",
    ratioRR: "1:2 — 1:3",
    descripcion: "伦敦交易时段（中欧时间07:00-10:00）是加密货币市场波动性最大的时段之一，与纽约开盘时段并列。欧洲机构投资者进入市场并创造直接的价格波动。价格通常会突破亚洲夜间形成的盘整区间。",
    condicionesEntrada: [
      "1. 识别亚洲交易时段（中欧时间00:00-07:00）的盘整区间：最高点和最低点。",
      "2. 在15分钟图表上标记这些水平位。",
      "3. 从中欧时间07:00开始等待突破亚洲区间。",
      "4. 在明确突破区间的第一根15分钟K线收盘时入场。",
      "5. 替代方案：在5分钟图上等待突破区间的微回测。"
    ],
    stopLoss: "设置在亚洲区间的相反极端位置。",
    takeProfit: "从突破点投射亚洲区间的高度作为目标。",
    ejemploReal: "BTC在夜间处于43,500-44,200区间。中欧时间07:15，15分钟K线收盘于44,350。入场44,350，止损43,500，目标44,900。",
    erroresComunes: [
      "在4小时图趋势相反的情况下操作伦敦开盘突破。",
      "重要宏观经济事件发布日：不要使用此策略。",
      "亚洲区间过窄（<0.5%）导致风险回报比不佳。"
    ],
    consejosPro: [
      "当亚洲区间整夜持续且无假突破时效果最佳。",
      "结合当日宏观市场倾向：如果市场处于上升趋势，仅做向上突破。",
      "统计数据显示，周一和周二的伦敦开盘突破最为清晰。"
    ]
  }
];

export const ESTRATEGIA_TIPOS = [
  {
    id: "todas",
    label: "全部"
  },
  {
    id: "tendencia",
    label: "趋势"
  },
  {
    id: "reversion",
    label: "反转"
  },
  {
    id: "ruptura",
    label: "突破"
  },
  {
    id: "rango",
    label: "盘整区间"
  },
  {
    id: "scalping",
    label: "剥头皮交易"
  }
];

export const ESTRATEGIA_NIVELES = [
  {
    id: "todas",
    label: "全部"
  },
  {
    id: "basica",
    label: "基础"
  },
  {
    id: "intermedia",
    label: "中级"
  },
  {
    id: "avanzada",
    label: "高级"
  }
];
